const PAGEWORKER_PAGES = ['CategoryPage', 'ProductPage'];

export const enablePageworkerScript = (pageType: string): boolean => {
  return PAGEWORKER_PAGES.includes(pageType);
};
